(function () {
  'use strict';

  // ROOT is the absolute root and currently also answers as the Latam regional root.
  // The region roots below are all direct children of ROOT.
  const roots = {
        ROOT: {id: 1, uuid: '00000000-0000-0000-0000-000000000001'},
        NA: {id: 1000000000, uuid: '00000000-0000-0000-0000-000000000002'},
        EU: {id: 1000000001, uuid: '00000000-0000-0000-0000-000000000003'},
        LATAM: {id: 1000000002, uuid: '00000000-0000-0000-0000-000000000004'}
      },
      funcoes = {
        getIds: () => Object.keys(roots).map(key => roots[key].id)
      };

  angular
    .module('enumModule')
    .constant('RootUoEnum', Object.assign({}, roots, funcoes));
}());
